import e from"styled-components";import{COLORS as i}from"../../constants/Theme.js";const t=e.div`
	background-color: #28034e;
	width: 88px;
	justify-content: space-between;
	position: sticky;
	top: 0;
	left: 0;
	z-index: 10;
	overflow-y: auto;
	height: 100vh;

	.bik-header-logo {
		margin: 24px 15.39px 8px 15.39px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		width: 57px;
		height: 20px;
		cursor: pointer;
		img {
			width: 100%;
			height: 100%;
			object-fit: container;
		}
	}

	.sticky-menu {
		@media (min-height: 768px) {
			position: absolute;
			bottom: 0px;
			width: 85%;
		}
	}
	.sticky-menu-int {
		@media (min-height: 768px) {
			position: absolute;
			bottom: 64px;
			width: 85%;
		}
	}

	.sticky-menu-three {
		@media (min-height: 768px) {
			position: absolute;
			bottom: 128px;
			width: 85%;
		}
	}

	.new-menu-item {
		padding-top: 14px;
	}
`,o=e.div`
	margin: 16px 0px;
`,n=e.div`
	.main--sidebar {
		overflow-y: auto;
		padding: 0px 8px;
		margin-bottom: 6px;
		> * {
			gap: 8px;
		}
	}
	.locked--channel {
		position: absolute;
		right: 10px;
		margin-top: -5px;
	}

	.new-tag {
		position: absolute;
		right: 5px;
		background: ${i.stroke.warning.vibrant} !important;
		font-size: 7.7px;
		font-family: 'Inter';
		line-height: 10px;
		padding: 2px 9.27px 2px 9.27px;
		border-radius: 16px 16px 0px 16px;
		background: ${i.background.inverse};
	}

	.tag-sticky {
		@media (min-height: 768px) {
			bottom: 116px;
			z-index: 1;
		}
	}
	.tag-sticky-2 {
		@media (min-height: 768px) {
			bottom: 48px;
			z-index: 1;
		}
	}

	.sidebar-menu-item {
		display: flex;
		flex-direction: column;
		border-radius: 10px;
		align-items: center;
		justify-content: space-around;
		cursor: pointer;
		> * {
			gap: 10px;
		}
		padding: 8px;
	}

	.menu-item-container {
		display: flex;
		flex-direction: row;
		cursor: pointer;
		.menu-item-text {
			font-family: 'Inter';
			font-style: normal;
			font-weight: 400;
			font-size: 12px;
			line-height: 16px;
			user-select: none;
			color: ${i.content.secondaryInverse};
			margin-bottom: 0px;
			text-align: center;
		}
		.active-menu-item-text {
			color: ${i.background.warning.vibrant};
		}
	}
	.main-menu-active-class {
		border-radius: 10px;
		background-color: #381062;
		color: ${i.background.warning.vibrant};
	}
	.sidebar-menu-item-hover {
		background: #381062;
		border-radius: 8px;
	}
	.sidebar-menu-item:hover {
		background: #381062;
		border-radius: 8px;
	}
`,r=e.div`
	.transform-class {
		position: relative;
		animation: animatebottom 0.5s;
		transition-timing-function: ease-in;
	}
	@keyframes animatebottom {
		from {
			width: 88px;
			opacity: 0;
		}

		to {
			width: 200px;
			opacity: 1;
		}
	}
	.sidebar-right-menu {
		position: ${e=>e.postion?e.postion:"sticky"};
		top: ${e=>e.top?e.top:0}px;
		left: ${e=>e.left?e.left:0}px; //88
		width: ${e=>e.width?e.width:200}px;
		z-index: ${e=>e.zIndex?e.zIndex:2};
		background-color: ${e=>"brand"==e.theme?"#381062":i.surface.standard};
		height: ${e=>e.isNewSidebar?"fit-content":"100vh"};
		display: flex;
		flex-direction: column;
		padding: 8px;
		border-radius: ${e=>e.isNewSidebar?"12px":""};
	}

	.sub-child-menu {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: ${e=>e.isNewSidebar?"":"8px"};
		cursor: pointer;
		.sub-child-text {
			color: ${e=>"brand"==e.theme?i.surface.standard:""};
			margin-bottom: 0px;
			padding: 8px 12px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.sub-child-new-tag {
			padding: 2px 9px 2px 9px;
			border-radius: 16px;
			background-color: rgba(254, 192, 45, 1);
			font-family: Inter;
			font-size: 7px;
			font-weight: 600;
			line-height: 10px;
			color: rgba(40, 3, 78, 1);
		}
		.sub-child-active-text {
			border-radius: 0px 4px 4px 0px;
			width: 2px;
			height: 12px;
			background: ${e=>e.isNewSidebar?i.background.warning.vibrant:"white"};
		}
		.active-bold-weight {
			font-weight: 600;
			color: ${e=>e.isNewSidebar?i.background.warning.vibrant:""};
		}
		.sub-child-active-menu-style {
			color: ${e=>e.isNewSidebar?i.background.warning.vibrant:""};
		}
	}
	.sub-child-menu:hover {
		background: ${e=>"brand"==e.theme?i.background.inverseLight:i.background.base};
		border-radius: 8px;
	}
	.sub-child-active-menu {
		background: ${e=>"brand"==e.theme?i.background.inverseLight:i.background.base};
		border-radius: 8px;
	}
	.sub-child-display-name {
		padding: 14px 12px;
		color: ${e=>"brand"==e.theme?i.content.secondaryInverse:i.text.secondary};
	}
	.lower-sticky-panel {
		position: ${e=>e.isNewSidebar?"relative":"absolute"};
		bottom: ${e=>e.isNewSidebar?"":"16px"};
		margin-top: ${e=>e.isNewSidebar?"auto":""};
		margin-bottom: ${e=>e.isNewSidebar?"16px":""};
		.title-text {
			padding: 8px 12px;
			text-align: center;
		}
		.upgrade-button {
			margin: auto;
		}
	}
	.sidebar-skeleton {
		padding: 8px;
	}
`,a=e.div`
	.sidebar-right-menu {
		border-radius: 4px;
		border: 0.5px solid var(--stroke-color-stroke-primary, #e0e0e0);
		box-shadow: 0px 0px 12px 0px rgba(222, 236, 255, 0.6);
		position: ${e=>e.postion?e.postion:"sticky"};
		top: ${e=>e.top?e.top:void 0}px;
		bottom: 10px;
		left: ${e=>e.left?e.left:0}px; //88
		z-index: ${e=>e.zIndex?e.zIndex:2};
		background-color: ${e=>"brand"==e.theme?"#381062":i.surface.standard};
		display: flex;
		flex-direction: column;
		padding: 12px;
		gap: 4px;
		min-height: 100px;
		overflow-y: auto;
	}
	.each-menu {
		padding: 8px;
		gap: 4px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		border-bottom: 0.5px solid #e0e0e0;
		cursor: pointer;
		max-width: 320px;
		:hover {
			background-color: ${i.background.base};
			border-radius: 8px;
		}
	}
`;export{o as MainSideBarMenuWrapper,n as SibeBarMenuItem,t as SideBarContainer,a as SidebarPopupContainer,r as SimpleSidebarContainer};
